import { ChangeDetectorRef, Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { JWTUser } from 'Model';
import { PlanDto } from 'app/models/dto';
import { PaymentService } from 'app/services/payment.service';
import { PlanService } from 'app/services/plan.service';
import { UtilserviceService } from 'app/services/utilservice.service';
import { environment } from 'environments/environment';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-upgrade',
  templateUrl: './upgrade.component.html',
  styleUrls: ['./upgrade.component.css']
})
export class UpgradeComponent implements OnInit {

  plans: Array<PlanDto> = []
  style: any;
  windowMessageReceivedHandler;
  paymentWindow: Window;
  disableBtn: boolean = false;
  envData: any;
  paymentRedirectUrl: string;
  constructor(private planServices: PlanService, private util: UtilserviceService, private paymentServices: PaymentService, private toastr: ToastrService, public cdr: ChangeDetectorRef) {
    this.windowMessageReceivedHandler = this.windowMessageReceived.bind(this);

  }


  async windowMessageReceived(event) {

    //debugger;
    if (event.data.type == 'paymentdone') {
      if (event.data.responsecode == '0') {
        this.toastr.success('Payment Successful');
        window.location.assign("/dashboard");
      }
      else {
        if (isNaN(event.data.responsecode)) {
          this.toastr.error(event.data.reason, 'Payment Error', { timeOut: 0, closeButton: true });
        }
        else {
          this.toastr.warning(event.data.reason, 'Payment Processing...', { timeOut: 0, closeButton: true });
        }
      }
      this.closePaymentWindow();
    }
  }
  async ngOnInit() {
    try {
      this.plans = await this.planServices.getPlans();
      this.envData = this.util.getDomainEnviroment();
      this.style = this.util.getDomainEnviroment().style;
      window.addEventListener('message', this.windowMessageReceivedHandler);
    } catch (error) {
      console.log(error);
    }
  }
  ngOnDestroy(): void {
    window.removeEventListener('message', this.windowMessageReceivedHandler);
  }
  canBuy(p:PlanDto){
    if(!this.envData.data.landingpage.showexclusiveplanprice && p.credits === -1){
        return false;
    }
    return true;
  }
  async buyPlan(p: any) {
   try {    
    let user = JSON.parse(this.util.getCurrentUser()) as JWTUser;
    let data = {
      "PlanId": p.id,
      "Email": user.email,
      "Domain": user.domain
    }
    this.disableBtn = true;
    let res = await this.paymentServices.buyPlan(data);

    this.openPaymentWindow(res.url);
   } catch (error) {
    console.log(error);
    
   }finally{
    this.disableBtn = false;
   }
    // const anchor = this.renderer.createElement('a');

    // // Set attributes (e.g., href and target)
    // this.renderer.setAttribute(anchor, 'href', res.url);
    // this.renderer.setAttribute(anchor, 'target', '_blank'); // Open link in a new tab or window

    // this.renderer.appendChild(this.el.nativeElement, anchor);
    // anchor.click();

    // // Remove the anchor tag from the DOM
    // this.renderer.removeChild(this.el.nativeElement, anchor);
  }

  openPaymentWindow(url) {
    this.closePaymentWindow();
    this.paymentWindow = window.open(url);
    let checkWindowClosedInterval = setInterval(() => {     
      if (this.paymentWindow == null) {
        this.paymentRedirectUrl = url;
        this.cdr.detectChanges();
      }
      else{        
        this.paymentRedirectUrl = '';
        this.cdr.detectChanges();
        clearInterval(checkWindowClosedInterval);
      }
    }, 500);
  }

  closePaymentWindow() {
    if (this.paymentWindow) {
      this.paymentWindow.close();
    }
    this.disableBtn = false;
    this.paymentWindow = null;
  }
}
